module.exports = __webpack_public_path__ + "img/s2.125fca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s2.png
// module id = Jk5r
// module chunks = 1